import {setAmplitudeUserProperties, trackAmplitudeEvent} from "@pg-mono/amplitude";

import {setProfilePictureAuthKind} from "../../user/utils/profile_picture";

export enum AmplitudeAuthMethod {
    INTERNAL = "internal",
    FACEBOOK = "facebook",
    GOOGLE = "google",
    GOOGLE_POPUP = "google_popup"
}

export enum AmplitudeAuthPlacement {
    KM = "km",
    KM_LP = "km_lp"
}

enum AmplitudeAuthEvent {
    SIGN_UP_CLICK = "sign_up_click",
    LOGIN_CLICK = "login_click",
    SIGNED_UP = "signed_up",
    LOGGED_IN = "logged_in"
}

enum AmplitudeAuthEventPropertyKey {
    SIGN_UP_METHOD = "sign_up_method",
    SIGN_UP_PLACEMENT = "sign_up_placement",
    SIGNED_UP_METHOD = "signed_up_method",
    SIGNED_UP_PLACEMENT = "signed_up_placement",
    LOGIN_METHOD = "login_method",
    LOGIN_PLACEMENT = "login_placement"
}

interface IAmplitudeAuthEventPropertyMapping {
    methodKey: AmplitudeAuthEventPropertyKey;
    placementKey: AmplitudeAuthEventPropertyKey;
}

type AmplitudeAuthEventPropertiesMap = {
    [event in AmplitudeAuthEvent]: IAmplitudeAuthEventPropertyMapping;
};

const AUTH_EVENT_PROPERTIES: AmplitudeAuthEventPropertiesMap = {
    [AmplitudeAuthEvent.SIGN_UP_CLICK]: {
        methodKey: AmplitudeAuthEventPropertyKey.SIGN_UP_METHOD,
        placementKey: AmplitudeAuthEventPropertyKey.SIGN_UP_PLACEMENT
    },
    [AmplitudeAuthEvent.SIGNED_UP]: {
        methodKey: AmplitudeAuthEventPropertyKey.SIGNED_UP_METHOD,
        placementKey: AmplitudeAuthEventPropertyKey.SIGNED_UP_PLACEMENT
    },
    [AmplitudeAuthEvent.LOGIN_CLICK]: {
        methodKey: AmplitudeAuthEventPropertyKey.LOGIN_METHOD,
        placementKey: AmplitudeAuthEventPropertyKey.LOGIN_PLACEMENT
    },
    [AmplitudeAuthEvent.LOGGED_IN]: {
        methodKey: AmplitudeAuthEventPropertyKey.LOGIN_METHOD,
        placementKey: AmplitudeAuthEventPropertyKey.LOGIN_PLACEMENT
    }
};

export class AuthAmplitudeTracker {
    private static track(event: AmplitudeAuthEvent, method: AmplitudeAuthMethod, placement: AmplitudeAuthPlacement) {
        const {methodKey, placementKey} = AUTH_EVENT_PROPERTIES[event];
        const eventProperties = {
            [methodKey]: method,
            [placementKey]: placement
        };

        trackAmplitudeEvent(event, eventProperties);
    }

    static landingSignUpClick() {
        this.track(AmplitudeAuthEvent.SIGN_UP_CLICK, AmplitudeAuthMethod.INTERNAL, AmplitudeAuthPlacement.KM_LP);
    }

    static landingLoginClick() {
        this.track(AmplitudeAuthEvent.LOGIN_CLICK, AmplitudeAuthMethod.INTERNAL, AmplitudeAuthPlacement.KM_LP);
    }

    static getPlacementForAuthContext(isModalOpen: boolean) {
        return isModalOpen ? AmplitudeAuthPlacement.KM : AmplitudeAuthPlacement.KM_LP;
    }

    static internalSignUpClick(placement: AmplitudeAuthPlacement) {
        this.track(AmplitudeAuthEvent.SIGN_UP_CLICK, AmplitudeAuthMethod.INTERNAL, placement);
    }

    static internalLoginClick(placement: AmplitudeAuthPlacement) {
        this.track(AmplitudeAuthEvent.LOGIN_CLICK, AmplitudeAuthMethod.INTERNAL, placement);
    }

    static internalSignedUp(placement: AmplitudeAuthPlacement) {
        setProfilePictureAuthKind("email");
        setAmplitudeUserProperties({profile_picture_captured: null});
        this.track(AmplitudeAuthEvent.SIGNED_UP, AmplitudeAuthMethod.INTERNAL, placement);
    }

    static internalLoggedIn(placement: AmplitudeAuthPlacement) {
        setProfilePictureAuthKind("email");
        setAmplitudeUserProperties({profile_picture_captured: null});
        this.track(AmplitudeAuthEvent.LOGGED_IN, AmplitudeAuthMethod.INTERNAL, placement);
    }

    static socialClick(isRegistration: boolean, method: AmplitudeAuthMethod, placement: AmplitudeAuthPlacement) {
        this.track(isRegistration ? AmplitudeAuthEvent.SIGN_UP_CLICK : AmplitudeAuthEvent.LOGIN_CLICK, method, placement);
    }

    static socialSuccess(isNewUser: boolean, method: AmplitudeAuthMethod, placement: AmplitudeAuthPlacement) {
        setProfilePictureAuthKind("sso");
        this.track(isNewUser ? AmplitudeAuthEvent.SIGNED_UP : AmplitudeAuthEvent.LOGGED_IN, method, placement);
    }
}
import {setAmplitudeUserProperties, trackAmplitudeEvent} from "@pg-mono/amplitude";

import {setProfilePictureAuthKind} from "../../user/utils/profile_picture";

export enum AmplitudeAuthMethod {
    INTERNAL = "internal",
    FACEBOOK = "facebook",
    GOOGLE = "google",
    GOOGLE_POPUP = "google_popup"
}

export enum AmplitudeAuthPlacement {
    KM = "km",
    KM_LP = "km_lp"
}

enum AmplitudeAuthEvent {
    SIGN_UP_CLICK = "sign_up_click",
    LOGIN_CLICK = "login_click",
    SIGNED_UP = "signed_up",
    LOGGED_IN = "logged_in"
}

enum AmplitudeAuthEventPropertyKey {
    SIGN_UP_METHOD = "sign_up_method",
    SIGN_UP_PLACEMENT = "sign_up_placement",
    SIGNED_UP_METHOD = "signed_up_method",
    SIGNED_UP_PLACEMENT = "signed_up_placement",
    LOGIN_METHOD = "login_method",
    LOGIN_PLACEMENT = "login_placement"
}

interface IAmplitudeAuthEventPropertyMapping {
    methodKey: AmplitudeAuthEventPropertyKey;
    placementKey: AmplitudeAuthEventPropertyKey;
}

type AmplitudeAuthEventPropertiesMap = {
    [event in AmplitudeAuthEvent]: IAmplitudeAuthEventPropertyMapping;
};

const AUTH_EVENT_PROPERTIES: AmplitudeAuthEventPropertiesMap = {
    [AmplitudeAuthEvent.SIGN_UP_CLICK]: {
        methodKey: AmplitudeAuthEventPropertyKey.SIGN_UP_METHOD,
        placementKey: AmplitudeAuthEventPropertyKey.SIGN_UP_PLACEMENT
    },
    [AmplitudeAuthEvent.SIGNED_UP]: {
        methodKey: AmplitudeAuthEventPropertyKey.SIGNED_UP_METHOD,
        placementKey: AmplitudeAuthEventPropertyKey.SIGNED_UP_PLACEMENT
    },
    [AmplitudeAuthEvent.LOGIN_CLICK]: {
        methodKey: AmplitudeAuthEventPropertyKey.LOGIN_METHOD,
        placementKey: AmplitudeAuthEventPropertyKey.LOGIN_PLACEMENT
    },
    [AmplitudeAuthEvent.LOGGED_IN]: {
        methodKey: AmplitudeAuthEventPropertyKey.LOGIN_METHOD,
        placementKey: AmplitudeAuthEventPropertyKey.LOGIN_PLACEMENT
    }
};

export class AuthAmplitudeTracker {
    private static track(event: AmplitudeAuthEvent, method: AmplitudeAuthMethod, placement: AmplitudeAuthPlacement) {
        const {methodKey, placementKey} = AUTH_EVENT_PROPERTIES[event];
        const eventProperties = {
            [methodKey]: method,
            [placementKey]: placement
        };

        trackAmplitudeEvent(event, eventProperties);
    }

    static landingSignUpClick() {
        this.track(AmplitudeAuthEvent.SIGN_UP_CLICK, AmplitudeAuthMethod.INTERNAL, AmplitudeAuthPlacement.KM_LP);
    }

    static landingLoginClick() {
        this.track(AmplitudeAuthEvent.LOGIN_CLICK, AmplitudeAuthMethod.INTERNAL, AmplitudeAuthPlacement.KM_LP);
    }

    static getPlacementForAuthContext(isModalOpen: boolean) {
        return isModalOpen ? AmplitudeAuthPlacement.KM : AmplitudeAuthPlacement.KM_LP;
    }

    static internalSignUpClick(placement: AmplitudeAuthPlacement) {
        this.track(AmplitudeAuthEvent.SIGN_UP_CLICK, AmplitudeAuthMethod.INTERNAL, placement);
    }

    static internalLoginClick(placement: AmplitudeAuthPlacement) {
        this.track(AmplitudeAuthEvent.LOGIN_CLICK, AmplitudeAuthMethod.INTERNAL, placement);
    }

    static internalSignedUp(placement: AmplitudeAuthPlacement) {
        setProfilePictureAuthKind("email");
        setAmplitudeUserProperties({profile_picture_captured: null});
        this.track(AmplitudeAuthEvent.SIGNED_UP, AmplitudeAuthMethod.INTERNAL, placement);
    }

    static internalLoggedIn(placement: AmplitudeAuthPlacement) {
        setProfilePictureAuthKind("email");
        setAmplitudeUserProperties({profile_picture_captured: null});
        this.track(AmplitudeAuthEvent.LOGGED_IN, AmplitudeAuthMethod.INTERNAL, placement);
    }

    static socialClick(isRegistration: boolean, method: AmplitudeAuthMethod, placement: AmplitudeAuthPlacement) {
        this.track(isRegistration ? AmplitudeAuthEvent.SIGN_UP_CLICK : AmplitudeAuthEvent.LOGIN_CLICK, method, placement);
    }

    static socialSuccess(isNewUser: boolean, method: AmplitudeAuthMethod, placement: AmplitudeAuthPlacement) {
        setProfilePictureAuthKind("sso");
        this.track(isNewUser ? AmplitudeAuthEvent.SIGNED_UP : AmplitudeAuthEvent.LOGGED_IN, method, placement);
    }
}
